module.exports = __webpack_public_path__ + "img/video-to-video.3c9841dc.svg";